import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 组件
import "./plugins/element.js";
import "./plugins/baiduMap.js";
import dataV from "@jiaminghi/data-view";
import * as echarts from "echarts";
// import zhejiangmap from './assets/mapjson/zhejiang.json'
import Charts from "@jiaminghi/charts";
import "./assets/style/style.scss";

// window.zhejiangData = zhejiangmap
// echarts.registerMap('zhejiangmap',zhejiangmap)

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.prototype.$Charts = Charts;
Vue.use(dataV);
Vue.use(ElementUI);

// 路由守卫
router.beforeEach((to, from, next) => {
    if (localStorage.getItem("isLogin")) {
        next();
    } else {
        if (to.path === "/login") {
            next();
        } else {
            next("/login");
        }
    }
});

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount("#app");
